/*require('./../style/chat-window.less');*/
var template = require('../template/chat-window.html');
var $ = require('jQuery');
var Component = require('./Component');
var Input = require('./input/Input');
var MsgViewer = require('./msg/MsgViewer');
var Shortcut = require('./input/plugin/Shortcut');
var Emotion = require('./input/plugin/Emotion');
var Image = require('./input/plugin/Image');
var File = require('./input/plugin/File');
var UserContactinfo = require('./input/plugin/UserContactinfo');
var Editor = require('./input/editor/index');
var StaticInput = require('./input/staticInput/StaticInput');
var ChatWindowHeader = require('./chatwindow-header/ChatWindowHeader');
var ChatFloat = require('./ChatFloat');
var Feedback = require('./chatwindow-header/plugin/Feedback');
var Panel = require('./chatwindow-header/panel/Panel');
var dispatcher = require('./../global/dispatcher');
var ContactStatus = require('./../constant/ContactStatus');
var MsgStatus = require('./../constant/MsgStatus');
var ActionType = require('./../constant/ActionType');
var MultipleContentMenu = require('./../constant/MultipleContentMenu');
var Timer = require('./../../lib/Timer');
var config = require('./../global/config');
var gdic = require('./../global/globalDic');
var falseNewsDic = require('./../global/falseNewsDic');
var gatherExistFalseMsgs = falseNewsDic.gatherExistFalseMsgs;
var strToNumCompare = require('./../../lib/util').strToNumCompare;
var FloatWindow = require('./FloatWindow');
var NoticeList = require('./addon/notice/NoticeList');
var ContentMenu = require('./addon/contentMenu/ContentMenu');
var MultipleMenu = require('./addon/multipleMenu/MultipleMenu');
var utils = require('./../global/utils');
var isGroupUser = utils.isGroupUser;
var isShopModeUser = utils.isShopModeUser;
var isEmpty = utils.isEmpty;
var isAnonymousSession = utils.isAnonymousSession;
var is_remind_helper = utils.is_remind_helper;

var non_forward_show_types = MultipleContentMenu.non_forward_show_types;
var non_delete_show_types = MultipleContentMenu.non_delete_show_types;
var non_collect_show_types = MultipleContentMenu.non_collect_show_types;
var non_withdraw_show_types = MultipleContentMenu.non_withdraw_show_types;
// 替换消息处理标记
var _LastReplaceMsg = {};           //key:user_id@user_source value:msgObj
// 自定义业务会话
var business_session = [];
var _LastAtMsg = {};               // key: groupId_groupSource ,val: { name {id, source, name} }

function InitVideoCalls(actionType) {
  var self = this;
  dispatcher.dispatch({
    type: actionType,
    data: {
      to_id: self._contact.user_id,
      to_source: self._contact.user_source
    }
  });
}

var switchAudioVideo = function (boolean) {
  // 暂时不开放音视频入口
  var self = this;
  if (self._lastVideoStatus == boolean) {
    return;
  }
  var ele = this.getElement().find(".chat-audio");
  var ele1 = this.getElement().find(".chat-video");
  if (ele.length !== 0 && ele1.length !== 0) {
    if (boolean) {
      ele.show();
      ele1.show();
    } else {
      ele.hide();
      ele1.hide();
    }
  } else if (ele.length == 0 && ele1.length == 0 && boolean) {
    if (window.wbWebRTCSDK && window.wbWebRTCSDK.isSupport) {
      wbWebRTCSDK.isSupportVideo(function (res) {
        if (res) {
          self._element && self._element.find('.im-input-plugins').append('<a href="javascript:;" class="chat-audio"><i></i></a><a href="javascript:;" class="chat-video"><i></i></a>');
        } else {
          self._element && self._element.find('.im-input-plugins').append('<a href="javascript:;" class="chat-audio"><i></i></a>');
        }
      }, function (e) { });
      self._element.find('.im-input-plugins').click(function (e) {
        var isAudio = $.contains(self._element.find('.chat-audio')[0], e.target);
        var isVideo = $.contains(self._element.find('.chat-video')[0], e.target);
        isAudio && InitVideoCalls.call(self, ActionType.CHAT_AUDIO);
        isVideo && InitVideoCalls.call(self, ActionType.CHAT_VIDEO);
      });
      self._lastVideoStatus = boolean;
    }
  }
};
var ChatWindow = function (options) {
  // 当前聊天的对象
  this._contact = null;
  // 是否已经获取了旧消息
  this._hasFetchedOldMsg = false;
  // 加载新信息的timer
  this._fetchMsgTimer = null;
  // 替换撤回消息内容的timer
  this._fetchReplaceMsgTimer = null;
  this._feedback = null;
  this._lastVideoStatus = false;

  (function (self) {
    var defaults = {
      template: template,
      getFreshMsgRecords: function (opts, cb) {    // 获取新鲜的消息
        cb([]);
      },
      getReplaceMsgRecords: function (opts, cb) {    // 获取新鲜的消息
        cb([]);
      },
      getOldMsgRecords: function (opts, cb, fail) {      // 获取过去的消息
        cb([]);
      },
      getDeletedMsgRecords: function (opts, cb) {    // 获取删除的消息
        cb([]);
      }
    };
    $.extend(defaults, options);
    Component.call(self, defaults);
  })(this);

  (function (self) {
    // chatwindow-header
    var cwheader_plugins = [];
    self.feedback = new Feedback({
      texts: []
    });
    cwheader_plugins.push(self.feedback);
    self._children['cwheader'] = new ChatWindowHeader({
      plugins: cwheader_plugins
    });
    self._element.find('.im-chatwindow-header').append(self._children['cwheader'].getElement());
    if (config.organization.enabled && !self._options._anonymousLogined) {
      // 添加新建群的按钮
      self._element.find('.im-cwheader-plugins').append('<i class="im-organization-icon" style="cursor:pointer">&nbsp;</i>');
      self._element.find('.im-feedback').addClass('im-support-group');
    }
    self._children['chatfloat'] = new ChatFloat({

    });
    self._children['chatfloat'].addEventListener('chat_open_organiz', function () {
      self.triggerEvent('organizstructureInit');
    });
    // self._children['chatfloat'].init(self._element.find('.im-chatfloat-container'));
    // self._element.find('.im-chatfloat-container').append(self._children['chatfloat'].getElement());

    // input
    var input_plugins = [];
    input_plugins.push(new Emotion());

    input_plugins.push(new Shortcut({
      // texts: config['msg-shortcut']
      texts: ['']
    }));

    if (typeof FileReader != "undefined") {
      input_plugins.push(new Image());
      input_plugins.push(new File());
    }
    //用户名片
    if (config['is_support_provide_contactinfo']) {
      input_plugins.push(new UserContactinfo());
    }

    if (!self._options._anonymousLogined) {
      self._children['input'] = new Input({
        plugins: input_plugins,
        editor: new Editor({
          _entrust_keycodes: [13, 38, 40]
        })
      });
      self._element.find('.im-chatwindow-input').append(self._children['input'].getElement());
    } else {
      self._children['staticInput'] = new StaticInput({

      });
      self._children['staticInput'].addEventListener('staticOutput', function (output) {
        dispatcher.dispatch({
          type: ActionType.STATIC_SEND_MESSAGE,
          data: {
            to_id: self._contact.user_id,
            to_source: self._contact.user_source,
            text: output || '',
            in_group: self._contact.in_group
          }
        });
      });
      self._children['staticInput'].addEventListener('staticLogin', function () {
        dispatcher.dispatch({
          type: ActionType.STATIC_LOGIN,
          data: {
            to_id: self._contact.user_id,
            to_source: self._contact.user_source,
            in_group: self._contact.in_group
          }
        });
      });
      self._element.find('.im-chatwindow-input').append(self._children['staticInput'].getElement());
    }

    // msgViewer
    self._children['msgViewer'] = new MsgViewer({
      me: config['me']()
    });
    self._element.find('.im-chatwindow-content').append(self._children['msgViewer'].getElement());

    self._children['msgViewer'].addEventListener('oldMsgNeed', (function () {
      // 用来避免多次查询
      var isFetching = false;
      // 老的聊天记录是否查询到底了
      var isEnding = false;
      var load_records_count = 0;
      return function (oldmsg) {
        if (isEnding) {
          return;
        }
        if (isFetching)
          return;
        isFetching = true;
        self._children['msgViewer'].startLoading();
        var msg_id = oldmsg ? oldmsg.msg_id : null;
        var count = 10;
        var opts = {
          user_id: self._contact.user_id,
          user_source: self._contact.user_source,
          last_msg_id: strToNumCompare(msg_id, self._children['msgViewer'].min_msg_id) > 0 ? self._children['msgViewer'].min_msg_id : msg_id,
          count: count,
          shop_id: self._contact.shop_id,
          shop_source: self._contact.shop_source
        }
        self._options.getOldMsgRecords(opts, function (msgs, min_msg_id) {
          self._children['msgViewer'].min_msg_id = min_msg_id;
          // 如果查询失败
          if (!msgs) {
            isFetching = false;
            return self._children['msgViewer'].scrollMsgId = '';
          }
          if (msgs.length < count) {
            isEnding = true;
          }
          var tmpKey = self._contact.user_id + '@' + self._contact.user_source;
          if (self._contact.shop_id && self._contact.shop_source) {
            tmpKey += '@@' + self._contact.shop_id + '@' + self._contact.shop_source;
          }
          var _msgs = [];
          for (var index = 0; index < msgs.length; index++) {
            if (msgs[index].msg_id) {
              _msgs.push(msgs[index]);
              // if (!self._contact.shop_id) {
              _msgs = _msgs.concat(gatherExistFalseMsgs(tmpKey, msgs[index].msg_id));
              // }
            }
          }
          isFetching = false;
          self._children['msgViewer'].markScroll();
          self._children['msgViewer'].stopLoading();
          self._children['msgViewer'].addMsg(_msgs);
          self._children['msgViewer'].gotoMark();
          self._children['msgViewer'].checkfull();
          self._hasFetchedOldMsg = true;
          var key = self._contact.user_id + "@" + self._contact.user_source;
          if (self._contact.shop_id && self._contact.shop_source) {
            key += '@@' + self._contact.shop_id + '@' + self._contact.shop_source;
          }
          _LastReplaceMsg[key] = self._children['msgViewer'].getFreshMsg();

          // 获取最后一条消息,同步到会话列表最后一条消息
          // if (self._data.contact.is_group == true && load_records_count == 0) {
          //   var session_username = $('body').find('.im-session-user').find('.im-session-username');
          //   for (var i = 0; i < session_username.length; i++) {
          //     if (session_username[i].innerHTML == self._contact.user_name) {
          //       if (msgs[0].show_type === 'operation_tip') {
          //         session_username[i].parentElement.children[3].innerHTML = msgs[0].content.default_text;
          //       } else {
          //         var last_txt = ((msgs[0].sender_info && msgs[0].sender_info.remark && msgs[0].sender_info.remark.remark_name) ? msgs[0].sender_info.remark.remark_name : (msgs[0].sender_info && msgs[0].sender_info.nick_name) ? msgs[0].sender_info.nick_name : msgs[0].sender_info.user_name) + ':' + msgs[0].content.msg;
          //         session_username[i].parentElement.children[3].innerHTML = last_txt;
          //       }
          //     }
          //   }

          //   load_records_count++;
          // }

          // 
          var _isExist = false;
          if (business_session.length > 0) {
            business_session.forEach(item => {
              // business_session中已经存在联系人及对应业务会话
              if (item.userId == self._contact.user_id) {
                _isExist = true;
              }
            });
          }
          // 根据历史消息（最后一条，最多追溯到倒数后5条的refer信息），获取不同业务会话
          if (!_isExist && !isEmpty(msgs) && msgs.length) {
            for (var i = 0; i < msgs.length; i++) {
              var invitation = (typeof msgs[i].refer == 'string' && msgs[i].refer.indexOf("invitation") !== -1) ? JSON.parse(msgs[i].refer).invitation : '';
              if (!isEmpty(invitation)) {
                /*注：由于js不能直接请求无线接口，需要服务端先做处理；此次请求暂不使用 */
                // 请求无线接口
                // var _key = '61e2e9e0d3e683bdfb96b66f60a07f31';
                // var _data = {
                //   userid: msgs[i].sender_id,
                //   myuserid: msgs[i].to_id,
                //   infoid: invitation.id
                // };
                // var _dataKey = encrypt(JSON.stringify(_data));
                // var params = {
                //   rootcateid: invitation.rootcateid,
                //   cateid: invitation.cateid,
                //   key: _key,
                //   data: _dataKey,
                //   // scene: invitation.scene,
                //   myrole: invitation.role,
                //   quickmsgcode: ''
                // }
                // var _url = '//app.58.com/api/im/index/getinfo';
                // ajax({
                //   type: "get",
                //   url: _url,
                //   dataType: 'jsonp',
                //   contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                //   encrypt: false,
                //   query: params,
                //   timeout: null,
                //   success: function (res) {
                //     console.log('++++++++++++++++++++++++++++++++++++', res);
                //     business_session.push({userId: self._contact.user_id, quickmsgs: res.quickMsg.msg});
                //     params.quickmsgcode =  res.quickMsg.md5code;
                //   },
                //   error: function (err) {
                //     console.log('================', err);
                //   }
                // });

                var rootcateid = invitation.rootcateid;
                // var cateid = invitation.cateid;
                // 查找匹配的业务线
                config['business-msg-shortcut'].forEach(item => {
                  if (item.rootcateid == rootcateid) {
                    business_session.push({ userId: self._contact.user_id, quickmsgs: item.quickmsgs });
                  }
                })
                break;
              }
            }

          }

        }, function (error) {
          // 群解散无法拉取到历史记录
          if (error && error.error_code + '' == '44007') {
            self._children['msgViewer'].stopLoading();
            self._hasFetchedOldMsg = true;
            return self._children['msgViewer'].scrollMsgId = '';
          }
        });
      };
    })());

    self._children['msgViewer'].addEventListener('onClick', function (message) {
      dispatcher.dispatch({
        type: ActionType.MSG_CLICK,
        data: {
          message: message,
          in_group: self._contact.in_group
        }
      });
    });

    self._children['msgViewer'].addEventListener('falseMsgCall', function (callType) {
      callType === 'audio' && InitVideoCalls.call(self, ActionType.CHAT_AUDIO);
      callType === 'video' && InitVideoCalls.call(self, ActionType.CHAT_VIDEO);
    })

    self._children['msgViewer'].addEventListener('reditContent', function (data) {
      self._children['input'] && self._children['input']._options.editor.update(data.content);
    });

    self._children['noticelist'] = new NoticeList({});
    self._element.find('.im-noticelist-container').append(self._children['noticelist'].getElement());

    self._children['noticelist'].addEventListener('aiSend', function (value) {
      dispatcher.dispatch({
        type: ActionType.AI_SEND,
        data: {
          to_id: self._contact.user_id,
          to_source: self._contact.user_source,
          text: value.text,
          qalog: value.qalog,
          in_group: self._contact.in_group
        }
      });
    });

    self._children['noticelist'].addEventListener('aiCopy', function (value) {
      self._children['input'] && self._children['input']._options.editor.update(value.text);
      dispatcher.dispatch({
        type: ActionType.AI_COPY,
        data: {
          to_id: self._contact.user_id,
          to_source: self._contact.user_source,
          text: value.text,
          qalog: value.qalog
        }
      });
    });

    self._children['noticelist'].addEventListener('noticeClose', function (noticeCount) {
      self._children['msgViewer'].fold(noticeCount * 37);
    });

    self._children['contentmenu'] = new ContentMenu({});

    self._element.find('.im-menu-container').append(self._children['contentmenu'].getElement());

    self._children['contentmenu'].addEventListener('click', function (item) {
      switch (item.action) {
        case 'forward':
          dispatcher.dispatch({
            type: ActionType.MULTIPLE_FORWARD_WINDOW_OPEN,
            data: {
              messages: [{
                _data: {
                  msg: item.message
                }
              }],
              forward_one_by_one: true
            }
          });
          self._element.find('.im-menu-container').hide();
          self._children['contentmenu'].hide();
          break;
        case 'collection':
          // todo
          self._element.find('.im-menu-container').hide();
          self._children['contentmenu'].hide();
          var selected_messages = [item.message];
          dispatcher.dispatch({
            type: ActionType.ADD_COLLECTION,
            data: {
              messages: selected_messages,
              other_id: self._contact.user_id + '@@' + self._contact.user_source,
            }
          });
          break;
        case 'withdraw':
          dispatcher.dispatch({
            type: ActionType.MSG_WITHDRAW,
            data: {
              message: item.message
            }
          });

          self._element.find('.im-menu-container').hide();
          self._children['contentmenu'].hide();
          break;
        case 'multipleSelection':
          self._children['msgViewer'].multiple_select(item.e);
          self._element.find('.im-menu-container').hide();
          self._children['contentmenu'].hide();
          if (self._children['multiplemenu'] && self._children['multiplemenu']._options && !self._children['multiplemenu']._options.inited) {
            self._element.find('.im-multiplemenu-container').append(self._children['multiplemenu'].getElement());
            var selections = [
              {
                text: '删除',
                action: 'delete_together',
                icon: 'delete'
              }
            ];
            if (!self._options._anonymousLogined && !self._isAnonymousSession) {
              selections.unshift({
                text: '收藏',
                action: 'collect',
                icon: 'collect'
              })
            }
            if (config['is_support_forward'] && !self._options._anonymousLogined && !self._isAnonymousSession) {
              selections.unshift(
                {
                  text: '合并转发',
                  action: 'forward_together',
                  icon: 'forward'
                }
              );
              selections.unshift(
                {
                  text: '逐条转发',
                  action: 'forward_one_by_one',
                  icon: 'forward'
                }
              )
            }
            self._children['multiplemenu'].setData({
              selections: selections
            })
          }
          self._element.find('.im-multiplemenu-container').show();
          break;
        case 'delMsg':
          dispatcher.dispatch({
            type: ActionType.DEL_MSG,
            data: {
              message: item.message
            }
          });
          self._element.find('.im-menu-container').hide();
          self._children['contentmenu'].hide();
          break;
        default:
          break;
      }
    });

    self._children['multiplemenu'] = new MultipleMenu({
      inited: false
    });

    self._children['multiplemenu'].addEventListener('click', function (value) {
      var selected_messages = self._children['msgViewer'].multiple_check();
      if (value.action && value.action != 'multipleMenuClose') {
        if (!selected_messages || selected_messages.length == 0) {
          dispatcher.dispatch({
            type: ActionType.TOAST_SHOW,
            data: {
              content: '未选择任何消息',
              interval: 3000,
              type: 'new',
              iconStatus: 'fail'
            }
          });
          return;
        }
      }
      switch (value.action) {
        case 'multipleMenuClose':
          self._element.find('.im-multiplemenu-container').hide();
          self._children['msgViewer'].multiple_cancel();
          break;
        case 'forward_one_by_one':
        case 'forward_together':
          if (selected_messages && selected_messages.length) {
            dispatcher.dispatch({
              type: ActionType.MULTIPLE_FORWARD_WINDOW_OPEN,
              data: {
                messages: selected_messages,
                forward_one_by_one: (value.action === 'forward_one_by_one')
              }
            });
          }
          break;
        case 'collect':
          var messages = [];
          selected_messages.forEach(message => {
            messages.push(message._data.msg)
          });
          dispatcher.dispatch({
            type: ActionType.ADD_COLLECTION,
            data: {
              messages: messages,
              other_id: self._contact.user_id + '@@' + self._contact.user_source,
            }
          });
          break;
        case 'delete_together':
          var messages = [];
          selected_messages.forEach(message => {
            messages.push(message._data.msg)
          });
          dispatcher.dispatch({
            type: ActionType.DELETE_TOGETHER,
            data: {
              messages: messages
            }
          });
          break;
        default:
          break;
      }
    });

    self._children['msgViewer'].addEventListener('sendMessage', function (value) {
      dispatcher.dispatch({
        type: ActionType.CARD_SEND_MESSAGE,
        data: {
          to_id: self._contact.user_id,
          to_source: self._contact.user_source,
          text: value.text,
          in_group: self._contact.in_group
        }
      });
    });

    self._children['msgViewer'].addEventListener('contentMenuOpen', function (options) {
      var selections = [];
      if (options.message.msg_id <= 0 || (!isEmpty(options.message.status) && (options.message.status !== 'SUCCESS' && options.message.status !== 'DOWNLOADED'))) {
        return;
      }
      if (self._options._anonymousLogined) {
        return;
      }
      if (non_delete_show_types.indexOf(options.message.show_type) < 0) {
        selections.push({
          text: '删除',
          action: 'delMsg'
        });
      }
      selections.push({
        text: '多选',
        action: 'multipleSelection'
      });
      let is_anonymous_msg = true;
      if (options.message && options.message.sender_info && options.message.sender_info.register === 1) {
        is_anonymous_msg = false;
      }
      if (!self._isAnonymousSession && !is_anonymous_msg && config['is_support_forward'] && options.message && non_forward_show_types.indexOf(options.message.show_type) < 0) {
        selections.unshift({
          text: '转发',
          action: 'forward'
        });
      }
      if (!self._isAnonymousSession && !is_anonymous_msg && options.message && non_collect_show_types.indexOf(options.message.show_type) < 0) {
        selections.unshift({
          text: '收藏',
          action: 'collection'
        });
      }
      if (options.message.is_mine && !options.timeout && non_withdraw_show_types.indexOf(options.message.show_type) < 0) {
        selections.unshift({
          text: '撤销',
          action: 'withdraw'
        });
      }
      if (!selections.length) {
        return;
      }
      self._children['contentmenu'].setData({
        selections: selections,
        message: options.message,
        e: options.e
      });
      self._element.find('.im-menu-container').show();
      if (selections.length) self._element.find('.im-menu-container').css('left', options.position.x - self._element.offset().left).css('top', options.position.y - self._element.offset().top).show();
      self._children['contentmenu'].show();
      self._children['msgViewer']._options.contentOpened = true;
    });

    self._children['msgViewer'].addEventListener('contentMenuClose', function (options) {
      self._element.find('.im-menu-container').hide();
      self._children['contentmenu'].hide();
      self._children['msgViewer']._options.contentOpened = false;
      //self._element.find('.im-multiplemenu-container').hide();
    });

    self._children['floatwindow'] = new FloatWindow({});
    self._element.find('.im-chatwindow-float').append(self._children['floatwindow'].getElement());

    if (!self._options._anonymousLogined) self._children['floatwindow'].addEventListener('outputMessage', function (value) {
      // if (!self._contact.in_group) return;
      // self._children['floatwindow'].close();
      self._children['input']._options.editor.keyboardUnEntrust();
      var editor_content = self._children['input']._options.editor.get();
      var outputWords = value.user_name || '';
      var AtIndex;
      var EndIndex;
      var cut = false;
      var filter;
      var msg = editor_content.msg;
      // msg = msg.replace(/&nbsp;/gi, ' ');
      msg = msg.replace(/&nbsp;/gi, '&nbsp;');
      //换行处理
      msg = msg.replace(/<br>/gi, '\n');
      //&amp;处理
      msg = msg.replace(/&amp;/gi, '&');
      for (var index = 0; index < msg.length; index++) {
        if (msg[index] == '@' && !(!isNaN(AtIndex) && index - AtIndex <= 1)) {
          AtIndex = index;
          EndIndex = index;
          cut = false;
        }
        if (!isNaN(AtIndex) && EndIndex >= AtIndex && !cut && value.filter) {
          if (msg[index] == ' ' || msg[index] != '@' && value.filter.indexOf(msg[index]) < 0) {
            cut = true;
            EndIndex = index;
          }
        }
      }
      //EndIndex = (EndIndex == AtIndex) ? (editor_content.msg.length + 1) : EndIndex;
      if (!isNaN(AtIndex)) {
        var newEndIndex = (isGroupUser(self._contact) && EndIndex == AtIndex) ? (editor_content.msg.length + 1) : EndIndex + 1;
        outputWords = outputWords.replace(/&/gi, '&amp;');
        _outputWords = outputWords.replace(/( )+$/, '');
        if (outputWords !== _outputWords) {
          for(let index = outputWords.length - _outputWords.length;index>0;index--) {
            _outputWords += '&nbsp;';
          }
          outputWords = _outputWords;
        }
        self._children['input']._options.editor.clear();
        self._children['input']._options.editor.update(editor_content.msg.slice(0, AtIndex + 1) + outputWords + '  ' + editor_content.msg.slice(newEndIndex), {
          need_html_2: true
        });
        self._children['floatwindow'].close();
        if (_LastAtMsg[self._contact.user_id + '@' + self._contact.user_source]) {
          _LastAtMsg[self._contact.user_id + '@' + self._contact.user_source][outputWords] = value;
        } else {
          _LastAtMsg[self._contact.user_id + '@' + self._contact.user_source] = {};
          _LastAtMsg[self._contact.user_id + '@' + self._contact.user_source][outputWords] = value;
        }
      }
      self._element.find('.im-chatwindow-float').hide();
    });

    self._children['floatwindow'].addEventListener('floatWindowMove', function (positions) {
      var left = positions.left - self._element.offset().left;
      if (!isNaN(left)) self._element.find('.im-chatwindow-float').css({ left: left });
    });

    self._children['input'] && self._children['input'].addEventListener('inputCompleted', function (value) {
      var at_info = '';
      var list = [];
      var dict = {};
      var groupAts = _LastAtMsg[self._contact.user_id + '@' + self._contact.user_source];
      if (value.msg && value.msg.indexOf('@') >= 0) {
        let stack;
        for (var atKey in groupAts) {
          if (groupAts.hasOwnProperty(atKey) && groupAts[atKey]) {
            let name_index = (groupAts[atKey].name && groupAts[atKey].name.length) ? value.msg.indexOf('@' + groupAts[atKey].name) : undefined;
            let nick_name_index = (groupAts[atKey].nick_name && groupAts[atKey].nick_name.length) ? value.msg.indexOf('@' + groupAts[atKey].nick_name) : undefined;
            let user_name_index = (groupAts[atKey].user_name && groupAts[atKey].user_name.length) ? value.msg.indexOf('@' + groupAts[atKey].user_name) : undefined;
            if (name_index >= 0 && nick_name_index >= 0) {
              stack = name_index > nick_name_index ? nick_name_index : name_index;
            } else if (name_index >= 0 || nick_name_index >= 0) {
              stack = name_index >= 0 ? name_index : nick_name_index;
            }
            if (user_name_index >=0) {
              if (stack >= 0) {
                stack = user_name_index > stack ? stack : user_name_index;
              } else {
                stack = user_name_index
              }
            }
            if (!isNaN(stack)) {
              dict[atKey] = {
                min: stack
              };
              // let min;
              // if (!isEmpty(old)) {
              //   min = old.min;
              // } else {
              //   dict[atKey] = {};
              // }
              // if (!isNaN(min)) {
              //   min = stack > min ? min : stack;
              //   if (min === stack) {
              //     record = atKey;
              //   }
              // } else {
              //   min = stack;
              // }
              // dict[atKey].min = min;
            }
            stack = undefined;
          }
        }
        for (var record in dict) {
          if (!isEmpty(record) && dict[record]) {
            list.push({
              id: groupAts[record].id,
              source: parseInt(groupAts[record].source),
              pos_start: dict[record].min,
              pos_end: dict[record].min + record.length + 1
            });
          }
        }
        if (list.length) at_info = JSON.stringify({
          targets: list
        });
      }
      delete _LastAtMsg[self._contact.user_id + '@' + self._contact.user_source];
      self.groupAtClose();
      self._element.find('.im-chatwindow-float').hide();
      dispatcher.dispatch({
        type: ActionType.MSG_SEND_APPLY,
        data: {
          to_id: self._contact.user_id,
          to_source: self._contact.user_source,
          shop_id: self._contact.shop_id,
          shop_source: self._contact.shop_source,
          sender_id: self._contact.shop_id ? self._contact.shop_id : null,
          sender_source: self._contact.shop_source ? self._contact.shop_source : null,
          show_type: value.type,
          content: value,
          msg_type: self._contact.in_group && self._contact.in_group + '' === '1' ? 1005 : 2,
          at_info: at_info
        }
      });
    });
    self._children['input'] && self._children['input']._options.editor.addEventListener('inputChange', function (value) {
      var type = self._contact.in_group ? ActionType.INPUT_CHANGE : ActionType.PRIVATE_INPUT_CHANGE;
      dispatcher.dispatch({
        type: type,
        data: {
          to_id: self._contact.user_id,
          to_source: self._contact.user_source,
          content: value,
          msg_type: self._contact.in_group && self._contact.in_group + '' === '1' ? 1005 : 2
        }
      });
    });
    self._children['input'] && self._children['input']._options.editor.addEventListener('keyboardOutput', function (event) {
      if (self._contact.in_group) dispatcher.dispatch({
        type: ActionType.KEYBOARD_OUTPUT,
        data: {
          event: event
        }
      });
    });
    // 业务会话自定义
    self._children['input'] && self._children['input']._options.plugins[1].addEventListener('setBussinessSession', function (event) {
      var _haveQuickmsgs = false;
      config['msg-shortcut'] = [];
      if (business_session.length > 0) {
        business_session.forEach(item => {
          if (item.userId == self._contact.user_id) {
            config['msg-shortcut'] = item.quickmsgs;
            _haveQuickmsgs = true;
          }
        });
      }
      if (!_haveQuickmsgs) {
        config['msg-shortcut'] = ["你好", "在吗"];
      }
      // console.log('+++++++++++++++++++++++++++++++++:', business_session, config['msg-shortcut']); 
    });
    //索要用户名片
    self._children['input'] && self._children['input'].addEventListener('askContactinfo', function (value) {
      let contactinfo = {
        other_user_id: self._contact.user_id,
        other_user_source: self._contact.user_source,
      }
      dispatcher.dispatch({
        type: ActionType.ASK_CONTACTINFO,
        data: contactinfo
      })
    });

    self._children['input'] && self._children['input'].setMaxInputLength(1000);

    self._element.on('dragover', function (e) {
      e.preventDefault();
    });
    self._element.on('drop', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var dataTransfer = e.originalEvent.dataTransfer || e.dataTransfer || window.dataTransfer;
      var fs;
      if (dataTransfer.files.length) {
        fs = dataTransfer.files[0];
      } else if (dataTransfer.items.length) {
        for (var i = 0; i < dataTransfer.items.length; i++) {
          var item = dataTransfer.items[i];
          if (item.kind == 'file' && item.type.match(/^image\//i)) {
            fs = item.getAsFile();
          }
        }
      } else {
        return;
      }
      if (fs) {
        self._children['input'] && self._children['input'].imgSend(fs);
      }
    });
    self._element.on('click', function (e) {
      var ctfloat = self._children['chatfloat'];
      var floatCt = self._element.find('.im-chatfloat-container');
      if (ctfloat && ctfloat.opened) {
        ctfloat.opened = false;
        if (self._element.hasClass('im-three-part')) {
          var current_session = self._contact.user_id + '@' + self._contact.user_source;
          floatCt.html(gdic.get('detailHtmlObj[' + current_session + ']'));
        } else {
          floatCt.hide();
        }
      } else if ($(e.target).hasClass('im-organization-icon') && ctfloat && !ctfloat.opened) {
        if (self._isAnonymousSession || self._options._anonymousLogined) {
          return
        }
        ctfloat.opened = true;
        floatCt.show();
        floatCt.html(ctfloat.getElement());
        ctfloat.init(floatCt);
        dispatcher.dispatch({
          type: ActionType.GROUP_At_CONTACTS,
          data: {
            user_id: self._contact.user_id,
            user_source: self._contact.user_source,
            shop_id: self._contact.shop_id,
            shop_source: self._contact.shop_source
          }
        });
      }
      if (self.panel && self.panel._opened) {
        self.panel.close();
        self._element.find('.im-panel-container').hide();
      }
    })

    self._children['cwheader'].addEventListener('addBlackList', function () {
      dispatcher.dispatch({
        type: ActionType.ADD_BLACKLIST,
        data: {
          user_id: self._contact.user_id,
          user_source: self._contact.user_source,
          shop_id: self._contact.shop_id,
          shop_source: self._contact.shop_source
        }
      });
    });
    self._children['cwheader'].addEventListener('delBlackList', function () {
      dispatcher.dispatch({
        type: ActionType.DEL_BLACKLIST,
        data: {
          user_id: self._contact.user_id,
          user_source: self._contact.user_source,
          shop_id: self._contact.shop_id,
          shop_source: self._contact.shop_source
        }
      });
    });
    self._children['cwheader'].addEventListener('isBlackedCheck', function () {
      dispatcher.dispatch({
        type: ActionType.IS_BLACKED_CHECK,
        data: {
          user_id: self._contact.user_id,
          user_source: self._contact.user_source,
          shop_id: self._contact.shop_id,
          shop_source: self._contact.shop_source
        }
      });
    });
    self._children['cwheader'].addEventListener('complaints', function () {
      dispatcher.dispatch({
        type: ActionType.COMPLAINTS,
        data: {
          user_id: self._contact.user_id,
          user_source: self._contact.user_source,
          shop_id: self._contact.shop_id,
          shop_source: self._contact.shop_source
        }
      });
    });
    self._children['cwheader'].addEventListener('quitGroup', function () {
      dispatcher.dispatch({
        type: ActionType.QUIT_GROUP,
        data: {
          target_gid: self._contact.user_id,
          target_gsource: self._contact.user_source
        }
      });
    });
    self._children['cwheader'].addEventListener('getGroupQrCode', function () {
      dispatcher.dispatch({
        type: ActionType.GET_GROUP_QRCODE,
        data: {
          gid: self._contact.user_id,
          gsource: self._contact.user_source
        }
      });
    });
    self._children['cwheader'].addEventListener('groupNotice', function () {
      dispatcher.dispatch({
        type: ActionType.GROUP_NOTICE,
        data: {
          target_id: self._contact.user_id,
          target_source: self._contact.user_source
        }
      });
    });
    self._children['cwheader'].addEventListener('sesTop', function (boolean) {
      dispatcher.dispatch({
        type: ActionType.SES_TOP,
        data: {
          target_id: self._contact.user_id,
          target_source: self._contact.user_source,
          msg_set: {
            ses_top: boolean ? 1 : 0
          }
        }
      });
    });
    self._children['cwheader'].addEventListener('setSilent', function (boolean) {
      dispatcher.dispatch({
        type: ActionType.SET_SILENT,
        data: {
          target_id: self._contact.user_id,
          target_source: self._contact.user_source,
          msg_set: {
            silent: boolean ? 1 : 0
          }
        }
      });
    });
    self._children['cwheader'].addEventListener('setGroup', function () {
      dispatcher.dispatch({
        type: ActionType.SET_GROUP,
        data: {
          group_id: self._contact.user_id,
          group_source: self._contact.user_source,
          group_name: self._contact.user_name
        }
      });
    });

    self._children['cwheader'].addEventListener('setUserRemark', function () {
      var content = $('body').find(".im-remark-contain");
      var remark_bg = $('body').find(".im-remark-bg");

      content.show();
      remark_bg.show();
      var remark_list = content.find('#remark_name');
      remark_list[0].value = self._data.contact.remark.remark_name ? self._data.contact.remark.remark_name : '';
      remark_bg.click(function (e) {
        e.stopPropagation();
      });
      content.click(function (e) {
        e.stopPropagation();
      });
      content.find('#remark_name').keyup(function (e) {
        var remark_len = remark_list[0].value.length;
        if (remark_len >= 30) {
          content.find('.remark_warn').show();
        } else {
          content.find('.remark_warn').hide();
        }
      });

      // 提交备注
      content.find('.submit_remark').click(function (e) {
        if (!e.isPropagationStopped()) {
          var remark_name = remark_list[0].value;
          if (remark_name.length > 0 && remark_name.trim().length == 0) {
            // 备注全是空格，不执行请求
          } else {
            dispatcher.dispatch({
              type: ActionType.SET_USER_REMARK,
              data: {
                business_source: 0,
                remark_name: remark_name,
                remark_spell: '',
                remark_telephone: '',
                remark_info: '',
                description: '',
                nick_name: ''
              }
            });
          }
          content.hide();
          remark_bg.hide();
        }
        e.stopPropagation();
      });

      content.find('.cancel_remark').click(function (e) {
        content.hide();
        remark_bg.hide();
      });
    });

  })(this);

  (function (self) {
    self._chatReisterCb = function (action) {
      if (['MSG_SEND_STATUS_CHANGE', 'CONTACT_ONLINE_CHANGE', 'MSG_SYNC', 'MSG_HANDLER_STATUS_CHANGE', 'MSG_INFO_UPDATED', 'TOAST_SHOW'].indexOf(action.type) == -1) {
        return;
      }
      var actionKey = action.data.to_id + '@' + action.data.to_source;
      if (action.data && action.data.shop_id && action.data.shop_source) {
        actionKey += '@@' + action.data.shop_id + '@' + action.data.shop_source;
      }
      var contactKey = self._contact.user_id + '@' + self._contact.user_source;
      if (self._contact && self._contact.shop_id && self._contact.shop_source) {
        contactKey += '@@' + self._contact.shop_id + '@' + self._contact.shop_source;
      }
      switch (action.type) {
        case ActionType.MSG_SEND_STATUS_CHANGE:
          if (actionKey == contactKey) {
            switch (action.data.status) {
              case MsgStatus.UPLOADING:
                self._children['msgViewer'].addMsg(action.data);
                self._children['msgViewer'].scrollToBottom();
                break;
              case MsgStatus.UPLOAD_FAIL:
              case MsgStatus.FAIL:
              case MsgStatus.DOWNLOAD_FAIL:
              case MsgStatus.VIDEO_PLAY_ERROR:
                self._children['msgViewer'].updateMsg(action.data);
                break;
              case MsgStatus.SENDING:
                if (['image', 'file', 'video'].indexOf(action.data.content.type) !== -1) {
                  self._children['msgViewer'].updateMsg(action.data);
                }
                else {
                  self._children['msgViewer'].addMsg(action.data);
                  self._children['msgViewer'].scrollToBottom();
                }
                break;
              case MsgStatus.CANCEL_SENDING:
                self._children['msgViewer'].updateMsg(action.data);
                break;
              case MsgStatus.SUCCESS:
                self._children['msgViewer'].updateMsg(action.data);
                break;
              default:
                break;
            }
          }
          break;
        case ActionType.CONTACT_ONLINE_CHANGE:
          if (actionKey == contactKey) {
            self.setOnline(action.data.is_online);
          }
          break;
        case ActionType.MSG_SYNC:
          if (actionKey == contactKey) {
            if (action.data.delete_msg_id != null)
              self._children['msgViewer'].remove(null, action.data.delete_msg_id);
            self._children['msgViewer'].addMsg(action.data.msglist);
          }
          break;
        case ActionType.MSG_HANDLER_STATUS_CHANGE:
          // 添加是收到、发出消息判断
          var me = config['me']();
          var data_id, data_source;
          if (me.user_id == action.data.to_id && me.user_source == action.data.to_source) {
            data_id = 'sender_id';
            data_source = 'sender_source';
          }
          else {
            data_id = 'to_id';
            data_source = 'to_source';
          }
          if (self._contact.user_id == action.data[data_id] && self._contact.user_source == action.data[data_source]) {
            switch (action.data.status) {
              case MsgStatus.DOWNLOAD_FAIL:
              case MsgStatus.VIDEO_PLAY_ERROR:
                self._children['msgViewer'].updateMsg(action.data);
                break;
              default:
                break;
            }
          }
          break;
        case ActionType.MSG_INFO_UPDATED:
          if (actionKey == contactKey) {
            switch (action.data.status) {
              case MsgStatus.UPLOADING:
                self._children['msgViewer'].updateMsg(action.data);
                break;
              default:
                break;
            }
          }
          break;
        default:
          break;
      }
    };
    if (options && options.contact && options.contact.is_reload_session) {
      dispatcher.unregister(self._chatReisterCb);
    }
    dispatcher.register(self._chatReisterCb);
  })(this);

  (function (self) {
    var content = self._element.find(".im-chatwindow-content");
    content.find('.im-topic-icon').click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (content.hasClass('im-topic-min')) {
        content.removeClass('im-topic-min').addClass('im-topic');
      } else {
        content.addClass('im-topic-min').removeClass('im-topic');
      }
    });
  })(this);

  (function (self) {
    var contact = self._options.contact;
    var userKey = contact.user_id + '@' + contact.user_source;
    var detailHtml = config['getContactDetailInfo'](contact);
    gdic.set('detailHtmlObj[' + userKey + ']', detailHtml);
    if (detailHtml) {
      self._element.addClass('im-three-part');
      self._element.find('.im-chatfloat-container').html(detailHtml);
    }
  })(this);

};
ChatWindow.prototype = Object.create(Component.prototype);
ChatWindow.prototype.setContact = function (newContact) {
  let hasContact = false;
  let is_remind_helper = false;
  var contact = $.extend(true, {}, newContact)
  this._contact = contact;
  this.setData({
    contact: contact
  });

  // 判断是否支持群相关
  var texts = [];
  var iconMap;
  hasContact = !isEmpty(contact);
  is_remind_helper = hasContact && utils.is_remind_helper(contact.user_id, contact.user_source, contact.shop_id, contact.shop_source);
  let _isAnonymousSession = hasContact && isAnonymousSession(contact);
  this._isAnonymousSession = _isAnonymousSession;
  if (this._children['input'] && this._children['input']._options && this._children['input']._options.plugins) {
    this._children['input']._options.plugins.forEach((plugin) => {
      if (plugin instanceof UserContactinfo) {
        plugin.setData({
          is_anonymous_user: _isAnonymousSession
        });
      }
    })
  }
  if (!this._options._anonymousLogined && hasContact && !isEmpty(contact.msg_set) && !_isAnonymousSession) {
    if (!utils.is_remind_helper(contact.user_id, contact.user_source, contact.shop_id, contact.shop_source)) {
      texts.push(!isEmpty(contact.msg_set.ses_top) && contact.msg_set.ses_top == 0 ? '置顶' : '取消置顶');
    }
    if (!utils.is_file_helper(contact.user_id, contact.user_source)) {
      texts.push(!isEmpty(contact.msg_set.silent) && contact.msg_set.silent == 0 ? '免打扰' : '取消免打扰');
    }
  }
  if (!is_remind_helper) {
    this._element.find('.im-chatwindow-input').show();
  } else {
    this._element.find('.im-chatwindow-content').addClass('im-chatwindow-content-fullwindow');
  }
  if (!hasContact || is_remind_helper || _isAnonymousSession) {
    if (is_remind_helper) {
      iconMap = { 0: 1 }
    }
  } else if (isGroupUser(contact)) {
    // texts.push('删除并退出');
    if (contact && contact.group_info) {
      var authority = contact.group_info.authority;
      if (authority == 1) {
        //texts.push('群公告');
      }
      // texts.push('群二维码');
      if (config.organization.enabled) {
        texts.push('群设置');
        iconMap = { 2: 6 }
      }
      if (!this.panel) {
        this.panel = new Panel({
          is_authority: contact.group_info.authority == 1
        });
        this.panel.addEventListener('updateNickName', function (value) {
          dispatcher.dispatch({
            type: ActionType.UPDATE_NICKNAME,
            data: {
              user_id: value.id,
              user_source: value.source,
              nick_name: value.nick_name,
              old_nick_name: value.old_nick_name,
              authority: contact.group_info.authority
            }
          });
        });
        this.panel.addEventListener('groupNotice', function (value) {
          dispatcher.dispatch({
            type: ActionType.GROUP_NOTICE,
            data: {
              gid: contact.user_id,
              gsource: contact.user_source,
              old_group_notice: value.old_group_notice,
              group_notice: value.group_notice
            }
          });
        });
        this.panel.addEventListener('getGroupQrCode', function () {
          dispatcher.dispatch({
            type: ActionType.GET_GROUP_QRCODE,
            data: {
              gid: contact.user_id,
              gsource: contact.user_source
            }
          });
        });
        this.panel.addEventListener('quitGroup', function () {
          dispatcher.dispatch({
            type: ActionType.QUIT_GROUP,
            data: {
              target_gid: contact.user_id,
              target_gsource: contact.user_source
            }
          });
        });
        this.panel.addEventListener('disbandGroup', function () {
          dispatcher.dispatch({
            type: ActionType.DISBAND_GROUP,
            data: {
              target_gid: contact.user_id,
              target_gsource: contact.user_source
            }
          });
        });
        this.panel.addEventListener('addMember', function (value) {
          dispatcher.dispatch({
            type: ActionType.ADD_MEMBER_WIN,
            data: {
              contacts: value.contacts
            }
          });
        });
        this.panel.addEventListener('deleteMember', function (value) {
          dispatcher.dispatch({
            type: ActionType.DELETE_MEMBER_WIN,
            data: {
              contacts: value.contacts,
              id_sources: value.id_sources
            }
          });
        });
        this.panel.addEventListener('updateGroupName', function (value) {
          dispatcher.dispatch({
            type: ActionType.UPDATE_GROUPNAME,
            data: {
              old_group_name: value.old_group_name,
              group_name: value.group_name
            }
          });
        });
        this._element.find('.im-panel-container').append(this.panel.getElement());
      }
    }
  } else {
    if (!this._options._anonymousLogined && !utils.is_file_helper(contact.user_id, contact.user_source)) {
      texts = texts.concat(['屏蔽', '举报']);
      if (!isShopModeUser(contact)) {
        texts.push('备注');
      }
    }
  }

  this._children['cwheader'].updateFeedBackList(texts, iconMap);
};
ChatWindow.prototype.setOnline = function (isonline) {
  this.setData({
    is_online: isonline
  });
};
ChatWindow.prototype.render = function () {
  var self = this;
  var element = this.getElement();
  if (!(this._data && !isEmpty(this._data.contact)) || !element) {
    return
  }
  var contact = this._data.contact;
  var name = contact.remark && contact.remark.remark_name ? contact.remark.remark_name : contact.user_name ? contact.user_name : '未知';
  if ((isEmpty(name) || name == '未知') && isAnonymousSession(contact)) {
    name = '游客' + contact.user_id;
  }
  if (is_remind_helper(contact.user_id, contact.user_source, contact.shop_id, contact.shop_source)) {
    name = '提醒服务';
    contact.avatar = config['message_reminder'].avatar;
  }

  if (!isAnonymousSession(contact) && !isGroupUser(contact) && config['is_show_audio_video'] && !utils.is_file_helper(contact.user_id, contact.user_source) && !utils.is_remind_helper(contact.user_id, contact.user_source, contact.shop_id, contact.shop_source)) {
    self.switchAudioVideo(true);
  }

  if (isAnonymousSession(contact) || utils.is_remind_helper(contact.user_id, contact.user_source, contact.shop_id, contact.shop_source) || utils.is_file_helper(contact.user_id, contact.user_source)) {
    element.find('.im-organization-icon').hide();
  } else {
    element.find('.im-organization-icon').show();
  }
  //对于群聊和店铺，不需要用户名片入口
  if (contact && isShopModeUser(contact) || isGroupUser(contact)) {
    element.find('.im-contactinfo-icon').hide();
  }
  // 对于群聊用户，不需要在线状态标示
  if (contact && contact.in_group + '' === '1') {
    element.find('.im-contact-status').hide();
    // 增加群成员数量
    if (contact.group_info && contact.group_info.current_count !== 0) {
      var num = '(' + contact.group_info.current_count + ')';
      element.find('.im-contact-name').addClass('im-group');
      element.find('.im-contact-num').text(num);
    }
  } else {
    element.find('.im-contact-num').hide();
    if (this._data.is_online == ContactStatus.ONLINE) {
      element.find('.im-contact-status').addClass('im-online');
    }
    else {
      element.find('.im-contact-status').removeClass('im-online');
    }
  }

  // 如果是客服端的店铺会话，直接隐藏功能
  if (isShopModeUser(contact)) {
    if (!isEmpty(contact.shop_id) && !isEmpty(contact.shop_source)) {
      this._children['cwheader'].switchFeedbackIcon(false);
    }
    element.addClass('im-shop-chatwindow');
    element.find('.im-organization-icon').hide();
  } else if (!self._options._anonymousLogined && !isAnonymousSession(contact) && !utils.is_file_helper(contact.user_id, contact.user_source)) {
    this._children['cwheader'].switchFeedbackIcon(true);
    element.find('.im-organization-icon').show();
  }

  if (utils.isEmojiCharacter(name)) {
    element.find('.im-contact-name').addClass('need-space')
  }
  element.find('.im-contact-name').text(name);
  element.find('.im-input-richtext').on("focusout", function () {
    var selection, a;
    if (window.getSelection) {//非IE浏览器的处理
      selection = window.getSelection();
      //a = document.getSelection();
      //let b = document.selection.createRange();
    } else if (document.getSelection) {//ie的处理
      selection = document.getSelection();
    } else if (document.selection) {
      selection = document.selection.createRange();
    }
    if (selection && selection.rangeCount > 0) {
      var curRange = selection.getRangeAt(0);
      gdic.set('curRange', curRange);
    }
  });
};
ChatWindow.prototype.active = function () {
  var self = this;
  this.show();
  self._children['msgViewer'].checkfull();
  self._children['input'] && self._children['input']._options.editor.focus();
  if (!this._fetchMsgTimer) {
    this._fetchMsgTimer = new Timer({
      onElapsed: function (cb) {
        if (!self._hasFetchedOldMsg) {
          return cb();
        }
        var newestmsg = self._children['msgViewer'].getFreshMsg();
        var opts = {
          user_id: self._contact.user_id,
          user_source: self._contact.user_source,
          last_msg_id: newestmsg ? newestmsg.msg_id : null,
          last_msg: newestmsg ? newestmsg : null,
          count: 10,
          shop_id: self._contact.shop_id,
          shop_source: self._contact.shop_source
        }
        self._options.getFreshMsgRecords(opts, function (msgs) {
          // 对于同步出来的已经删除的消息，进行过滤
          // 对于店铺模式同一个用户的情况可能出现消息混乱进行过滤
          var contactTp = gdic.get('contact') ? gdic.get('contact') : null
          msgs = msgs.filter(function (item) {
            var cwKey, itemKey, itemKey1;
            if (contactTp) {
              var contactKey = contactTp.user_id + '@' + contactTp.user_source;
              var cwKey = contactKey;
              if (contactTp.shop_id && contactTp.shop_source) {
                cwKey += '@@' + contactTp.shop_id + '@' + contactTp.shop_source;
              } else {
                var me = config['me']();
                cwKey += '@@' + me.user_id + '@' + me.user_source;
              }
              var sendKey = item.sender_id + '@' + item.sender_source;
              var toKey = item.to_id + '@' + item.to_source;
              itemKey = sendKey + '@@' + toKey;
              itemKey1 = toKey + '@@' + sendKey;
            }
            return item.msg_status + '' !== '2' && (cwKey == itemKey || cwKey == itemKey1 || (isGroupUser(contactTp) && contactKey == toKey));
          })
          // 将页面临时展示消息插入到消息列表
          var tmpKey = 'tmpMsg-' + self._contact.user_id + '@' + self._contact.user_source;
          if (self._contact.shop_id && self._contact.shop_source) {
            tmpKey += '@@' + self._contact.shop_id + '@' + self._contact.shop_source;
          }
          var tmpMsgArr = gdic.get(tmpKey);
          if (tmpMsgArr instanceof Array) {
            // var savedFalseMsgs = [];
            // var _newestmsg = self._children['msgViewer'].getFreshMsg(true);
            // var latestMsgId = (_newestmsg && _newestmsg.msg_id) ? _newestmsg.msg_id : 0;
            // var _latestMsgId;
            // if(latestMsgId)tmpMsgArr.forEach(function(tmpMsg){
            //   if (tmpMsg.is_false_new && tmpMsg.is_saved) return;
            //   if (latestMsgId && !isEmpty(tmpMsg) && tmpMsg.is_false_new && isEmpty(tmpMsg.msg_id)) {
            //     _latestMsgId = latestMsgId;
            //     latestMsgId = sumBigNumber(latestMsgId, '1');
            //     tmpMsg.msg_id = latestMsgId;
            //     tmpMsg.tmpKey = tmpKey, 
            //     tmpMsg.follow_msg_id = _latestMsgId;
            //     savedFalseMsgs.push(tmpMsg);
            //   }
            // });
            // falseNewsDic.set(savedFalseMsgs);
            if (msgs instanceof Array) {
              msgs = msgs.concat(tmpMsgArr);
            }
            else {
              tmpMsgArr.push(msgs);
              msgs = tmpMsgArr;
            }
            // 从小到大排序
            msgs = msgs.sort(function (a, b) {
              return strToNumCompare(a.msg_id, b.msg_id) > 0 ? 1 : strToNumCompare(a.msg_id, b.msg_id) < 0 ? -1 : 0;
            });
            // 清空已用临时消息
            gdic.set(tmpKey, null);
          }
          if (msgs.length === 0) {
            return cb();
          }
          var inserted = self._children['msgViewer'].addMsg(msgs);
          if (inserted)
            self._children['msgViewer'].scrollToBottom();
          cb();
        });
      },
      duration: 500
    });
  }
  this._fetchMsgTimer.start();
  if (!this._fetchReplaceMsgTimer) {
    this._fetchReplaceMsgTimer = new Timer({
      onElapsed: function (cb) {
        if (!self._hasFetchedOldMsg) {
          return cb();
        }
        var key = self._contact.user_id + '@' + self._contact.user_source;
        if (self._contact.shop_id && self._contact.shop_source) {
          key += '@@' + self._contact.shop_id + '@' + self._contact.shop_source;
        }
        var opts = {
          user_id: self._contact.user_id,
          user_source: self._contact.user_source,
          last_msg_id: (_LastReplaceMsg && _LastReplaceMsg[key]) ? _LastReplaceMsg[key].msg_id : null,
          count: 10,
          shop_id: self._contact.shop_id,
          shop_source: self._contact.shop_source
        }
        self._options.getReplaceMsgRecords(opts, function (msgs) {
          self._children['msgViewer'].replaceMsg(msgs, function () {
            if (msgs instanceof Array) {
              if (msgs.length == 0) return;
              _LastReplaceMsg[key] = msgs[msgs.length - 1];
            }
            else {
              if (!msgs || msgs.length == 0 || JSON.stringify(msgs) == "{}") return;
              _LastReplaceMsg[key] = msgs;
            }
          });
          cb();
        });
      },
      duration: 500
    });
  }
  this._fetchReplaceMsgTimer.start();
  if (!this._fetchDeletedMsgTimer) {
    this._fetchDeletedMsgTimer = new Timer({
      onElapsed: function (cb) {
        var key = self._contact.user_id + '@' + self._contact.user_source;
        if (self._contact.shop_id && self._contact.shop_source) {
          key += '@@' + self._contact.shop_id + '@' + self._contact.shop_source;
        }
        var opts = {
          user_id: self._contact.user_id,
          user_source: self._contact.user_source,
          shop_id: self._contact.shop_id,
          shop_source: self._contact.shop_source
        }
        self._options.getDeletedMsgRecords(opts, function (msgs) {
          self._children['msgViewer'].hideMsg(msgs, function () {

          });
          cb();
        });
      },
      duration: 500
    });
  }
  this._fetchDeletedMsgTimer.start();
};
ChatWindow.prototype.unactive = function () {
  if (this._fetchMsgTimer) {
    this._fetchMsgTimer.stop();
    this._fetchMsgTimer = null;
  }
  if (this._fetchReplaceMsgTimer) {
    this._fetchReplaceMsgTimer.stop();
    this._fetchReplaceMsgTimer = null;
  }
  if (this._fetchDeletedMsgTimer) {
    this._fetchDeletedMsgTimer.stop();
    this._fetchDeletedMsgTimer = null;
  }
  this.hide();
};
// 设置聊天窗口的聊天主题
ChatWindow.prototype.setTopic = function (html) {
  var content = this._element.find(".im-chatwindow-content");
  var topic = content.find('.im-chatwindow-topic');
  if (html) {
    content.addClass("im-topic");
    if (html.indexOf('<img') == -1) {
      content.addClass("im-topic-no-img");
    }
    topic.find(".im-chatwindow-topic-content").html(html);
  } else {
    content.removeClass("im-topic");
  }
  this._children['msgViewer'].resetScroll();
};
// 设置匿名用户聊天的输入框
ChatWindow.prototype.setStaticInput = function (inputs) {
  this._children['staticInput'] && this._children['staticInput'].setData({
    inputs
  });
};
// 禁用输入框
ChatWindow.prototype.disableInput = function () {
  // this._children["input"].hide();
  this._element.addClass("im-disableinput");
  this.getElement().find('.im-contact-status').hide();
};
// 设置联系人标识
ChatWindow.prototype.setContactIdentification = function (html) {
  this.getElement().find(".im-contact-type").html(html);
};
// 滚动到底部
ChatWindow.prototype.scrollToBottom = function () {
  this._children['msgViewer'].scrollToBottom();
};
// 切换屏蔽和取消屏蔽按钮的状态
ChatWindow.prototype.updateHandleText = function (text) {
  this._children['cwheader'].updateHandleText(text);
};

ChatWindow.prototype.groupAtWindowRefresh = function (contacts, id_sources, count, filter) {
  var _id_sources = [];
  id_sources.forEach(function (id_source) {
    if (!isEmpty(contacts[id_source])) {
      _id_sources.push(id_source);
    }
  })
  this._children['floatwindow'].setData({
    contacts: contacts,
    id_sources: _id_sources,
    maxCount: count,
    filter: filter || ''
  });
  this._children['floatwindow'].reset();
  if (this._children['floatwindow']._options.opened) {
    this._children['input']._options.editor.keyboardEntrust();
  } else {
    this._children['input']._options.editor.keyboardUnEntrust();
  }
}

ChatWindow.prototype.keyboardInput = function (event) {
  this._children['floatwindow'].keyboardInput(event);
}

ChatWindow.prototype.updateNotices = function (notices) {
  notices = notices || [];
  this._children['noticelist'].setData({
    notices: notices
  });
  this._children['msgViewer'].fold(notices.length * 37);
}

ChatWindow.prototype.groupAtClose = function () {
  this._children['floatwindow'].close();
  this._children['input']._options.editor.keyboardUnEntrust();
}

ChatWindow.prototype.otherReadUpdate = function () {
  var self = this;
  self._children['msgViewer'].updateMsgOtherRead();
}

// 切换音视频按钮
ChatWindow.prototype.switchAudioVideo = function (boolean) {
  switchAudioVideo.call(this, boolean);
};

ChatWindow.prototype.refreshChatFloat = function () {
  let self = this;
  dispatcher.dispatch({
    type: ActionType.GROUP_At_CONTACTS,
    data: {
      user_id: self._contact.user_id,
      user_source: self._contact.user_source,
      shop_id: self._contact.shop_id,
      shop_source: self._contact.shop_source
    }
  });
};

ChatWindow.prototype._destroy = ChatWindow.prototype.destroy;

ChatWindow.prototype.destroy = function () {
  let self = this;
  dispatcher.unregister(self._chatReisterCb);
  self._destroy();
}

module.exports = ChatWindow;
